(function () {
  if (window.__ssbBuyBox) {
    window.__ssbBuyBox.sync();
    return;
  }
  var CFG = (window.__ssbBuyBox = { sync: sync });

  function attr(el, n) {
    return (el && el.getAttribute(n)) || '';
  }
  function list(el, sel) {
    return Array.prototype.slice.call(el.querySelectorAll(sel));
  }

  function currentOpt(box) {
    var l = list(box, '.ssb-opt');
    return l.filter(function (o) { return attr(o, 'aria-checked') === 'true'; })[0] || l[0];
  }

  function showErr(box, msg) {
    var e = box.querySelector('[data-ssb-err]');
    if (e) {
      e.textContent = msg;
      e.classList.add('show');
    }
  }
  function hideErr(box) {
    var e = box.querySelector('[data-ssb-err]');
    if (e) e.classList.remove('show');
  }

  function render(box, opt) {
    var ctaLabel = box.querySelector('[data-ssb-cta-label]');
    var guarantee = box.querySelector('[data-ssb-guarantee-text]');

    if (ctaLabel) ctaLabel.textContent = attr(opt, 'data-cta-label');
    if (guarantee) guarantee.textContent = attr(opt, 'data-guarantee');
  }

  function select(box, opt) {
    list(box, '.ssb-opt').forEach(function (o) {
      o.setAttribute('aria-checked', o === opt ? 'true' : 'false');
    });
    hideErr(box);
    render(box, opt);
  }

  function openCart() {
    ['cart:refresh', 'cart:build', 'cart-updated', 'cart:updated'].forEach(function (ev) {
      document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
    });
    var selectors = [
      '[data-ssb-cart-trigger]', '#cart-icon-bubble', '.js-drawer-open-cart',
      '[data-cart-drawer-toggle]', '[data-drawer-open="cart"]', '#CartDrawer-Toggle',
      'a[href="/cart"][aria-haspopup]', '.header__icon--cart'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        el.click();
        return;
      }
    }
  }

  function postToCart(items, onDone) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r
          .json()
          .catch(function () { return {}; })
          .then(function (body) {
            return { ok: r.ok, status: r.status, body: body };
          });
      })
      .then(onDone);
  }

  function addToCart(box) {
    var opt = currentOpt(box);
    if (!opt) return;
    var cta = box.querySelector('[data-ssb-cta]');
    var ctaLabel = box.querySelector('[data-ssb-cta-label]');
    var raw = attr(opt, 'data-items');

    var items;
    try {
      items = JSON.parse(raw);
    } catch (e) {
      console.error('[ssb] could not parse data-items:', raw, e);
      showErr(box, 'This option is not configured yet.');
      return;
    }

    cta.classList.add('is-adding');
    cta.disabled = true;
    hideErr(box);

    postToCart(items, function (res) {
      cta.classList.remove('is-adding');
      cta.disabled = false;
      if (!res.ok) {
        console.error('[ssb] /cart/add.js rejected this', res.status, res.body, 'sent:', items);
        showErr(
          box,
          res.body.description || res.body.message ||
            'Add to cart failed with status ' + res.status + '. Details are in the console.'
        );
        return;
      }
      openCart();
      if (ctaLabel) {
        ctaLabel.textContent = 'Added';
        setTimeout(function () {
          var c = currentOpt(box);
          if (c) ctaLabel.textContent = attr(c, 'data-cta-label');
        }, 1300);
      }
    }).catch(function (e) {
      cta.classList.remove('is-adding');
      cta.disabled = false;
      console.error('[ssb] could not reach /cart/add.js', e, 'sent:', items);
      showErr(box, 'Could not reach the cart. Please try again.');
    });
  }

  function addBundleToCart(btn) {
    var raw = attr(btn, 'data-items');
    var items;
    try {
      items = JSON.parse(raw);
    } catch (e) {
      console.error('[ssb] could not parse bundle data-items:', raw, e);
      return;
    }
    btn.classList.add('is-adding');
    btn.disabled = true;
    var label = btn.querySelector('[data-ssb-bundle-label]');
    var originalText = label ? label.textContent : '';

    postToCart(items, function (res) {
      btn.classList.remove('is-adding');
      btn.disabled = false;
      if (!res.ok) {
        console.error('[ssb] bundle /cart/add.js rejected this', res.status, res.body, 'sent:', items);
        return;
      }
      openCart();
      if (label) {
        label.textContent = 'Added';
        setTimeout(function () {
          label.textContent = originalText;
        }, 1300);
      }
    }).catch(function (e) {
      btn.classList.remove('is-adding');
      btn.disabled = false;
      console.error('[ssb] could not reach /cart/add.js for bundle', e, 'sent:', items);
    });
  }

  // ---- listeners, bound once to document --------------------------------
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var bundleBtn = t.closest('[data-ssb-bundle-add]');
    if (bundleBtn) {
      addBundleToCart(bundleBtn);
      return;
    }

    var box = t.closest('[data-ssb-buybox]');
    if (!box) return;
    var opt = t.closest('.ssb-opt');
    if (opt) {
      select(box, opt);
      return;
    }
    var cta = t.closest('[data-ssb-cta]');
    if (cta) addToCart(box);
  });

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var box = t.closest('[data-ssb-buybox]');
    if (!box) return;
    var opt = t.closest('.ssb-opt');
    if (!opt) return;
    var l = list(box, '.ssb-opt'),
      i = l.indexOf(opt),
      n;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
      e.preventDefault();
      n = l[(i + 1) % l.length];
      n.focus();
      select(box, n);
    }
    if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
      e.preventDefault();
      n = l[(i - 1 + l.length) % l.length];
      n.focus();
      select(box, n);
    }
  });

  // Cosmetic only. The markup already ships in its default (checked) state,
  // so the box is correct even if this never runs. Safe to call repeatedly.
  function sync() {
    list(document, '[data-ssb-buybox]').forEach(function (box) {
      var c = currentOpt(box);
      if (c) render(box, c);
    });
  }

  sync();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
})();
